import React from "react";
import { InputGroup } from "@blueprintjs/core";
import { isEmpty } from "lodash";
import { useState } from "react";
import { Table, TablePagination } from "workbench";
import { FORM_FIELD_TYPE } from "../../../../../constants";
import styles from "../../../../../styles/Campaigns/CampaignLogs.module.scss";
import Form from "../../../../common/Form";
import trackingElement from "../../../../common/TrackingElement";

// Theatres and Screens Details Panel Component
const convertToTrackingFormat = (value, changeType, oldValue) => {
  if (!changeType && oldValue) {
    return { old: oldValue, new: value };
  }
  if (!changeType) {
    return { old: value, new: undefined };
  }
  if (changeType === "removed") {
    return { old: value, new: "" };
  }
  if (changeType === "added") {
    return { old: "", new: value };
  }
  return { old: undefined, new: value };
};

const TheatreAndScreensDetailsPanel = ({ screens, targetGroupsName, targetGroupOldName }) => {
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedTargetGroup, setSelectedTargetGroup] = useState({ name: "All", value: "All" });
  const pageSize = 50;
  targetGroupsName = ["All", ...targetGroupsName];
  const filteredScreens =
    screens?.filter(
      (screen) =>
        (screen.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          screen.theatreName.toLowerCase().includes(searchTerm.toLowerCase()) ||
          (screen.cityName &&
            (screen.cityName.toLowerCase().includes(searchTerm.toLowerCase()) ||
              screen.provinceName.toLowerCase().includes(searchTerm.toLowerCase()) ||
              screen.countryName.toLowerCase().includes(searchTerm.toLowerCase())))) &&
        (screen.targetGroupName === selectedTargetGroup?.name ||
          selectedTargetGroup?.name === "All")
    ) ?? [];

  const columns = [
    {
      id: "name",
      Header: "Screen",
      accessor: (d) =>
        trackingElement(convertToTrackingFormat(`${d.theatreName} . ${d.name}`, d.changeType)),
    },
    {
      id: "cityName",
      Header: "Location",
      accessor: (d) => (
        <div>
          {trackingElement(
            convertToTrackingFormat(
              `${d.cityName}, ${d.provinceName}, ${d.countryName}`,
              d.changeType
            )
          )}
        </div>
      ),
    },
    {
      id: "targetGroup",
      Header: "Target Group",
      accessor: (d) =>
        trackingElement(
          convertToTrackingFormat(d.targetGroupName, d.changeType, targetGroupOldName)
        ),
    },
  ];
  return (
    <div className={styles.tableStyle}>
      <div className={styles.controlStyle}>
        <InputGroup
          onChange={(e) => setSearchTerm(e.target.value)}
          value={searchTerm}
          placeholder="Search by Screen or Location or Target Group¯"
          className={styles.searchInput}
        />
        <div className={styles.dropDownContainer}>
          <Form
            config={[
              {
                id: "targetGroupSelector",
                type: FORM_FIELD_TYPE.SELECT,
                placeHolder: "Select Target Group",
                onSelect: ([value]) => {
                  setSelectedTargetGroup(value);
                },
                label: selectedTargetGroup?.name,
                list: targetGroupsName.map((name) => ({
                  name: name,
                  value: name,
                  id: name,
                  label: name,
                })),
                selectedList: !isEmpty(selectedTargetGroup)
                  ? [selectedTargetGroup?.name]
                  : undefined,
                singleSelect: true,
              },
            ]}
          />
        </div>
        <TablePagination
          pageSize={pageSize}
          onPageChange={setPage}
          currentPage={page}
          totalRecords={filteredScreens.length}
        />
      </div>
      <Table
        data={filteredScreens?.slice((page - 1) * pageSize, page * pageSize) ?? []}
        columns={columns}
        pageSize={pageSize}
        onPageChange={setPage}
        currentPage={page}
      />
      <div className={styles.pageInfo}></div>
    </div>
  );
};
export default TheatreAndScreensDetailsPanel;
